// src/components/ui/Button.tsx
import React from "react";

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "ghost";
};

function getVariantClasses(variant: Props["variant"]) {
  if (variant === "secondary") {
    return "bg-white text-slate-900 ring-1 ring-slate-300 hover:bg-slate-50";
  }
  if (variant === "ghost") {
    return "bg-transparent text-slate-900 hover:bg-slate-100";
  }
  return "bg-slate-900 text-white hover:bg-slate-800";
}

export default function Button({
  variant = "primary",
  className,
  ...props
}: Props) {
  const base =
    "inline-flex items-center justify-center rounded-lg px-4 py-3 text-sm font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 disabled:cursor-not-allowed disabled:opacity-60";
  return (
    <button
      {...props}
      className={`${base} ${getVariantClasses(variant)} ${className ?? ""}`}
    />
  );
}
